import ClaimReviewListPageActionTypes from './claim-review-list-page-action-types';
import axios from 'axios';
import { sortingToStringWithSubstitutes } from '../../../utils/objectUtils';

export const loadClaimReviewListPage = () => async(dispatch) => {
  dispatch(findClaims());
};

export const findClaims = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: ClaimReviewListPageActionTypes.LOAD_CLAIM_REVIEW_LIST_START });
  const state = getState().claimReviewListPage;
  const query = {
    skip: payload ? payload.skip : state.skip,
    limit: payload ? payload.take : state.take,
    keyword: state.filter?.keyword,
    status: state.filter?.status?.id,
    sorting: sortingToStringWithSubstitutes(state.sorting, [
      { originalName: 'studentName', substituteName: 'StudentName' },
      { originalName: 'title', substituteName: 'Title' },
      { originalName: 'occurredAt', substituteName: 'OccurredAt' },
      { originalName: 'minutes', substituteName: 'Minutes' },
      { originalName: 'status', substituteName: 'Status' },
      { originalName: 'createdOn', substituteName: 'CreatedOn' }
    ])
  };
  try {
    state.cancelToken?.cancel();
    state.cancelToken = axios.CancelToken.source();
    const result = await api.get('api/general_competency_claims', query, state.cancelToken.token);
    const claims = result ? result.data.map(c => ({
      ...c,
      occurredAt: c.occurredAt ? new Date(c.occurredAt.substring(0, 10) + 'T12:00:00') : null,
      createdOn: c.createdOn ? new Date(c.createdOn) : null
    })) : [];
    dispatch({
      type: ClaimReviewListPageActionTypes.LOAD_CLAIM_REVIEW_LIST_END,
      payload: {
        claims,
        total: result ? result.total : 0,
        skip: payload ? payload.skip : state.skip,
        take: payload ? payload.take : state.take
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: ClaimReviewListPageActionTypes.LOAD_CLAIM_REVIEW_LIST_END });
      throw error;
    }
  }
};

export const filterClaims = (payload) => (dispatch) => {
  dispatch({
    type: ClaimReviewListPageActionTypes.FILTER_CLAIM_REVIEW_LIST,
    payload: payload
  });
  dispatch(findClaims());
};

export const clearClaimsFilter = () => (dispatch) => {
  dispatch({
    type: ClaimReviewListPageActionTypes.FILTER_CLAIM_REVIEW_LIST,
    payload: {}
  });
  dispatch(findClaims());
};

export const sortClaims = (payload) => (dispatch) => {
  dispatch({
    type: ClaimReviewListPageActionTypes.SORT_CLAIM_REVIEW_LIST,
    payload: payload
  });
  dispatch(findClaims());
};
